import { DBServicesApi } from '@tyrio/dto';
import { useDebounce } from '../../../hooks/useDebounce';
import api from '@tyrio/api-factory';
import { useQuery } from 'react-query';
import { isEmpty } from 'lodash';

export const useGetServices = (
  ean: string,
  warehouseId = 1,
  search: string,
  modalData: any[]
) => {
  const debouncedSearch = useDebounce(search, 500);
  const { data: recommendedServices, isFetching: isFetchingRecommended } =
    useQuery(
      [
        'get_recommended_services',
        {
          branchId: warehouseId?.toString(),
          eans: [ean],
        },
      ],
      async () => {
        return await api.fetch<DBServicesApi['recommended']>(
          'get_recommended_services',
          {
            branchId: warehouseId?.toString(),
            eans: [ean ?? ''],
          }
        );
      },
      {
        enabled: !isEmpty(ean) && modalData.length > 0,
      }
    );
  const { data: allServices, isFetching: isFetchingServices } = useQuery(
    [
      'get_services_by_branch_id',
      warehouseId?.toString(),
      { search: debouncedSearch },
    ],
    async () => {
      return await api.fetch<DBServicesApi['list']>(
        'get_services_by_branch_id',
        {
          branchId: warehouseId?.toString(),
          productEans: ean ?? '',
          search: debouncedSearch,
        }
      );
    },
    {
      enabled: !!warehouseId,
    }
  );

  const filteredService = allServices?.filter(
    (item) => !recommendedServices?.map((item) => item.code).includes(item.code)
  );

  return {
    recommendedServices,
    services: filteredService,
    isFetching: isFetchingServices || isFetchingRecommended,
  };
};
